import { environment } from "../environment";
import { PayloadBook } from "../models/books";
import { AsyncResult } from "../models/common/async-result";
import api from "./api";

export async function uploadUserImage(userId: number, payload): Promise<AsyncResult<number>> {
  const url = environment.api.files.userImage
    .replace('{userId}', String(userId))

  const formData = new FormData()

  formData.append('image', payload);

  const response = await api.post(url, formData)
    .then(resp => resp?.data.success)
    .catch(() => null);

  if (!response) return { error: 'Falha ao cadastrar imagem do perfil' }

  return { success: response };
}

export async function uploadClubImage(userId: number, payload): Promise<AsyncResult<number>> {
  const url = environment.api.files.clubImage
    .replace('{clubId}', String(userId))

  const formData = new FormData()

  formData.append('image', payload.file);
  formData.append('docRules', payload.docRules);

  const response = await api.post(url, formData)
    .then(resp => resp?.data.success)
    .catch(() => null);

  if (!response) return { error: 'Falha ao cadastrar imagem do perfil' }

  return { success: response };
}

export async function uploadBookImage(bookId: number, payload: PayloadBook): Promise<AsyncResult<number>> {
  const url = environment.api.files.bookImage
    .replace('{bookId}', String(bookId))

  const formData = new FormData()

  formData.append('image', payload.file);

  const response = await api.post(url, formData)
    .then(resp => resp?.data.success)
    .catch(() => null);

  if (!response) return { error: 'Falha ao cadastrar imagem do livro' }

  return { success: response };
}